export const formatPrice = (price) => {
  return new Intl.NumberFormat('ka-GE', {
    style: 'currency',
    currency: 'GEL',
    maximumFractionDigits: 0,
  }).format(Number(price || 0));
};

export default formatPrice;
